import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import { useModal } from '../../../hooks/use-modal';
import SummaryBar from '../components/summary-bar';
import NullStateOverlay from '../components/null-state-overlay';
import InsufficientDataBannerMessage from '../components/insufficient-data-banner-message';
import NewOrdersGraph from '../components/graphs/new-orders-graph';
import OpenOrderAgingGraph from '../components/graphs/open-order-aging-graph';
import ChangeSlaModal from '../components/graphs/open-order-aging-graph/change-sla-modal';
import { ShipmentsByCarrierTable } from '../components/shipments-by-carrier-table';
import { SalesByStoreTable } from '../components/sales-by-store-table';
import { doubleDash } from '../constants';
import { AutomationRecommendationsBanner } from '../../../global/automation-recommendations-banner';
import messages from './messages';
import style from './style.module.less';

const renderSummarySection = (orderSummary = emptyObject) => {
  const { totalOrderCount, awaitingShipmentCount, shippedCount } = orderSummary;
  const dataIsUndefined = totalOrderCount === undefined;
  const formattedData = [
    {
      title: <FormattedMessage {...messages.newOrdersLabel} />,
      value: dataIsUndefined ? doubleDash : <FormattedNumber value={totalOrderCount} />,
    },
    {
      title: <FormattedMessage {...messages.ordersShippedLabel} />,
      value: dataIsUndefined ? doubleDash : <FormattedNumber value={shippedCount} />,
    },
    {
      title: <FormattedMessage {...messages.ordersUnshippedLabel} />,
      value: dataIsUndefined ? doubleDash : <FormattedNumber value={awaitingShipmentCount} />,
    },
  ];
  return <SummaryBar className={style['summary-bar']} data={formattedData} />;
};

const Overview = ({ chartData = emptyObject }) => {
  const { open, close, isOpen } = useModal();
  const { orderByAge, orderByInterval, orderByStore, orderSummary, shipmentByCarrier } = chartData;
  const shouldShowNullOverlay = !orderSummary?.totalOrderCount;

  return (
    <>
      <AutomationRecommendationsBanner roundCorners />
      {shouldShowNullOverlay && <InsufficientDataBannerMessage />}
      <div className={style['new-orders-graph']}>
        {shouldShowNullOverlay && <NullStateOverlay />}
        <NewOrdersGraph data={orderByInterval} />
      </div>
      {renderSummarySection(orderSummary)}
      <div className={style.container}>
        <div className={style['chart-section']}>
          <ShipmentsByCarrierTable data={shipmentByCarrier} />
          <p>
            <Link to='/dashboard/reports/ShippingExtract'>
              <FormattedMessage {...messages.allShippedDataLink} />
            </Link>
          </p>
          <SalesByStoreTable data={orderByStore} />
        </div>
        <div className={style['chart-section']}>
          <div className={style['open-orders-aging-graph']}>
            <OpenOrderAgingGraph data={orderByAge} onChangeSla={open} width='100%' />
            {isOpen && <ChangeSlaModal onClose={close} />}
          </div>
        </div>
      </div>
    </>
  );
};

Overview.propTypes = {
  chartData: PropTypes.object,
};

export default Overview;
